import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const LogoMobile = ({
  width = 30,
  height = 33,
  fill = colors.light,
  responsive = false,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 31"
      aria-labelledby="mobileLogoTitle"
      focusable="false"
      role="img"
      {...svgAttributes}
    >
      <title id="mobileLogoTitle">Grossman Company Properties</title>
      <path
        d="M13.5252 32.2642V29.6984L13.0109 29.6292C10.3491 29.2774 7.83143 28.2223 5.72101 26.5741C3.6106 24.9258 1.98497 22.745 1.01407 20.2597C0.0431657 17.7743 -0.237346 15.0757 0.201858 12.4459C0.641061 9.81608 1.78385 7.3517 3.51075 5.31038C5.23765 3.26906 7.48524 1.72576 10.0185 0.84184C12.5519 -0.0420807 15.2778 -0.234166 17.9115 0.285664C20.5452 0.805495 22.9898 2.01815 24.9899 3.79686C26.9899 5.57556 28.4719 7.85499 29.2809 10.3968H26.1472C25.3619 8.47217 24.0849 6.78385 22.4422 5.49829C20.7995 4.21272 18.8477 3.37428 16.7792 3.06559C14.7106 2.75691 12.5968 2.98863 10.6459 3.73794C8.69509 4.48724 6.9746 5.72825 5.65401 7.33866C4.33343 8.94908 3.45834 10.8733 3.115 12.9217C2.77165 14.9701 2.9719 17.072 3.69601 19.0201C4.42011 20.9683 5.64308 22.6955 7.24438 24.0316C8.84568 25.3677 10.77 26.2665 12.8278 26.6394L13.5252 26.7692V23.7405L13.0588 23.6367C11.5882 23.3201 10.2206 22.6438 9.08002 21.6694C7.93947 20.695 7.06215 19.4532 6.52769 18.0567C5.99324 16.6603 5.81859 15.1535 6.01958 13.673C6.22058 12.1926 6.79087 10.7854 7.67867 9.57927C8.56647 8.37313 9.74367 7.40623 11.1034 6.76633C12.4631 6.12643 13.9623 5.83381 15.4649 5.91502C16.9674 5.99624 18.4257 6.44872 19.7074 7.2314C20.9891 8.01407 22.0536 9.10215 22.8042 10.3968H19.0429C18.3843 9.78662 17.5978 9.32874 16.7398 9.05608C15.8818 8.78342 14.9736 8.70275 14.0805 8.81986C13.1874 8.93697 12.3315 9.24896 11.5742 9.73342C10.8169 10.2179 10.1771 10.8628 9.70073 11.6218C9.22432 12.3809 8.92313 13.2352 8.81879 14.1236C8.71445 15.0119 8.80955 15.9121 9.09725 16.7596C9.38496 17.6071 9.85813 18.3809 10.4828 19.0253C11.1075 19.6697 11.8681 20.1688 12.7101 20.4868L13.5252 20.8156V13.4256H29.9128C29.9699 13.9124 29.999 14.4022 30 14.8923C29.9879 18.493 28.6648 21.968 26.2746 24.6763C23.8844 27.3847 20.5884 29.1437 16.9945 29.6292L16.4802 29.6984V32.2642H13.5252ZM22.813 19.3921C22.1823 20.4647 21.3354 21.3965 20.3252 22.1291C19.3149 22.8617 18.1632 23.3794 16.9422 23.6496L16.4802 23.7535V26.7822L17.1775 26.6524C19.5763 26.2061 21.7829 25.0498 23.5075 23.3354C25.232 21.6211 26.3938 19.429 26.8401 17.047L26.9665 16.3548H16.4802V20.8156L17.2952 20.4825C17.9344 20.2198 18.5239 19.8511 19.0386 19.3921H22.813Z"
        fill={fill}
      />
    </svg>
  )
}

export default LogoMobile
